import styled from 'styled-components';

import DivisionLine from 'ggApp/shared/components/layout/divisionLine';

import Card from './Card';

const Wrap = styled.div`
    padding-top: 12px;
`;

const Line = styled(DivisionLine)`
    margin: ${({ theme }) => `0 ${theme.spacers.L} ${theme.spacers.S}`};
`;

const ProductSection = styled.div`
    display: flex;
    flex-direction: column;
    margin: ${({ theme }) => `0 ${theme.spacers.M}`};
`;

const Product = styled(Card)``;

export {
    Wrap, ProductSection, Product, Line,
};
